import { useEffect, useState } from 'react';
import { shallowEqual, useSelector, useDispatch } from 'react-redux';
import { setStateValue } from '../../../../../actions/actionsModuloRelatorio';
import * as service from '../services';
import { getModelPanel } from '../../InfoPanel/utils';
import { ProductModuloRelatorio, ProdutoOption, RootState } from '../types';

export const useProductModuloRelatorio = () => {
  const [products, setProducts] = useState({
    list: [],
    cache: [],
    value: [],
  });
  const [timer, setTimer] = useState(null);

  const { filtrosData } = useSelector(
    (state: RootState) => ({
      filtrosData: state.painelGeralDataReducer?.filtrosData,
    }),
    shallowEqual,
  );
  const dispatch = useDispatch();
  const setList = (list: ProductModuloRelatorio[]) => {
    const newList = list.map(item => ({
      id: item.id,
      value: item.identificador,
      label: `${item.identificador} - ${item.descricao}`,
      identificador: item.identificador,
      descricao: item.descricao,
      datapoints: item.datapoints,
      limited: item.limited,
    }));

    const cacheList = products.cache;
    const removeDuplicate = newList.filter(i => !products.value.includes(i.value));
    const concatList = products.value.length ? cacheList.concat(removeDuplicate) : newList;

    setProducts(prevState => ({
      ...prevState,
      list: concatList,
    }));

    dispatch(setStateValue('filterProductEditionLoading', false));
  };

  const handleAddProduct = (item: ProdutoOption) => {
    setProducts(prevState => {
      const hasValue = prevState.value.includes(item.identificador);
      if (!hasValue) {
        return {
          ...prevState,
          value: prevState.value.concat(item.identificador),
          cache: prevState.cache.concat(item),
        };
      }
      return prevState;
    });
  };

  const handleRemoveProduct = (item: ProdutoOption) => {
    const hasValue = products.value.includes(item.identificador);
    if (hasValue) {
      const removedCache = products.cache.filter(i => i.identificador !== item.identificador);
      const newValue = products.value.filter(i => i !== item.identificador);
      setProducts(prevState => ({
        ...prevState,
        value: newValue,
        cache: removedCache,
      }));
    }
  };

  const handleCleanProduct = () => {
    setProducts(prevState => ({ ...prevState, value: [], cache: [] }));
  };

  const searchProducts = data => {
    service.getProdutoModuloRelatorio(data).then(response => {
      if (response) {
        setList(response);
      }
    });
  };

  const onSearchProducts = (inputValue: string) => {
    let filtros;

    if (inputValue && typeof inputValue === 'string' && inputValue.match(/^\d+ \d+[\d+ ]*$/)) {
      const concatValue = products.value.concat(inputValue.split(' '));
      const newValue = [...new Set(concatValue)];
      filtros = { query: '', identificadores: newValue };

      setProducts(prevState => ({
        ...prevState,
        value: newValue,
      }));
    } else {
      filtros = {
        query: typeof inputValue === 'string' ? inputValue : '',
      };
    }

    clearTimeout(timer);

    const newTimer = setTimeout(() => {
      searchProducts(getModelPanel(filtrosData, filtros.query, 'produto', filtros.identificadores ? filtros.identificadores : null));
    }, 500);

    setTimer(newTimer);
  };

  const setProductsForEdition = (inputValue: string) => {
    const concatValue = products.value.concat(inputValue.split(' '));
    const newValue = [...new Set(concatValue)];
    const filtros = { query: '', identificadores: newValue };

    setProducts(prevState => ({
      ...prevState,
      value: newValue,
    }));

    clearTimeout(timer);

    const newTimer = setTimeout(() => {
      searchProducts(getModelPanel(filtrosData, filtros.query, 'produto', filtros.identificadores ? filtros.identificadores : null));
    }, 500);

    setTimer(newTimer);
  };

  useEffect(() => {
    if (products.value.length) {
      const filterList = products.list.filter(cache => products.value.some(i => cache.identificador === i));

      if (filterList.length) {
        setProducts(prevState => ({
          ...prevState,
          cache: filterList,
        }));
      }
    }
  }, [products.value.length, products.list]);

  return {
    onSearchProducts,
    products,
    handleAddProduct,
    handleRemoveProduct,
    handleCleanProduct,
    setProductsForEdition,
  };
};
